import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";

type RoleLabelKey = "counselors.roles.supervisor" | "counselors.roles.counselor" | "volunteers.roleChip";

export function getRoleLabelKey(role: UserPermission): RoleLabelKey {
  switch (role) {
    case UserPermission.Supervisor:
      return "counselors.roles.supervisor";
    case UserPermission.Volunteer:
      return "volunteers.roleChip";
    default:
      return "counselors.roles.counselor";
  }
}
